import { useIntl } from "react-intl";

import { DEFAULT_VALUES } from "@/libraries/web-framework";

const Automation = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "ConfluencePricingPage.modalContents.Automation.title",
            defaultMessage: "Automation"
        }),
        content: intl.formatMessage(
            {
                id: "ConfluencePricingPage.modalContents.Automation.content",
                defaultMessage:
                    "<p>Build flexible rules to reduce manual tasks. Premium users have 1,000 rule executions per paid monthly user.</p> <p>For example, a Confluence Cloud Premium site with 200 users will have 200,000 monthly rule executions each month.</p> <p>Enterprise sites have unlimited automation executions.</p>"
            },
            { ...DEFAULT_VALUES }
        ),
        altText: intl.formatMessage({
            id: "ConfluencePricingPage.modalContents.Automation.altText",
            defaultMessage: "Example of an automation trigger"
        }),
        imageCaption: intl.formatMessage({
            id: "ConfluencePricingPage.modalContents.Automation.imageCaption",
            defaultMessage:
                "Here’s what an automation trigger looks like in Confluence."
        })
    };

    return (
        <div>
            <h2>{messages.title}</h2>
            {messages.content}
            <img
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/Rule-builder-component_list-2x_.webp"
                alt={messages.altText}
                height={350}
                loading="lazy"
            />
            <p>{messages.imageCaption}</p>
        </div>
    );
};

export default Automation;
